export default "__VITE_ASSET__42ac9116__"